import { NumberBox } from "devextreme-react";
import React from "react";

export default function TwoNumberBoxComponent(props) {
  const { firstNumberBox, secondNumberBox, formDataSource } = props;

  return (
    <React.Fragment>
      <NumberBox
        ref={firstNumberBox.ref}
        placeholder={firstNumberBox.placeholder}
        style={{
          float: "left",
          width: "49%",
          marginRight: "3px",
        }}
        showClearButton={true}
        format="#,##0"
        defaultValue={
          formDataSource ? formDataSource[firstNumberBox.field] : null
        }
      />
      <NumberBox
        ref={secondNumberBox.ref}
        placeholder={secondNumberBox.placeholder}
        style={{
          float: "left",
          width: "49%",
          marginRight: "3px",
        }}
        showClearButton={true}
        format="#,##0"
        defaultValue={
          formDataSource ? formDataSource[secondNumberBox.field] : null
        }
      />
    </React.Fragment>
  );
}
